import React from "react";

import {
  Column,
  Columns,
  Heading,
  MarkdownLite,
  Section,
  Stack,
  Text,
} from "@origin-digital/ods-core";

import content from "./content.json";
import { getImageFromCloudinary } from "src/utils/helpers";
import styled from "styled-components";

const Image = styled.img`
  width: 100%;
  max-width: 348px;
  height: auto;
`;

export const WhySection: React.FC = () => (
  <Section backgroundColor="grey50">
    <Stack
      space={{
        xs: "medium",
        sm: "medium",
        md: "xxlarge",
        lg: "xxlarge",
        xl: "xxlarge",
      }}
    >
      <Heading variant="h2" align="center">
        {content.heading}
      </Heading>
      <Columns
        collapseBelow="md"
        space={{
          xs: "xxlarge",
          sm: "xxlarge",
          md: "large",
          lg: "large",
          xl: "large",
        }}
      >
        {content.sections.slice(0, 3).map((section, index) => (
          <Column width="1/3" key={`why-section-${index}-top`}>
            <Stack alignX="center" space="large">
              <Image src={getImageFromCloudinary(196, 348, section.icon)} />
              <Text align="center">
                <MarkdownLite>{section.text}</MarkdownLite>
              </Text>
            </Stack>
          </Column>
        ))}
      </Columns>
      <Columns
        collapseBelow="md"
        space={{
          xs: "xxlarge",
          sm: "xxlarge",
          md: "large",
          lg: "large",
          xl: "large",
        }}
      >
        {content.sections.slice(3, 6).map((section, index) => (
          <Column width="1/3" key={`why-section-${index}-bottom`}>
            <Stack alignX="center">
              <Image src={getImageFromCloudinary(196, 348, section.icon)} />
              <Text align="center">
                <MarkdownLite>{section.text}</MarkdownLite>
              </Text>
            </Stack>
          </Column>
        ))}
      </Columns>
    </Stack>
  </Section>
);
